export const transformLanguagesTextData = ({ items, filteredCount }) => {
	const translateData = {};
	items.forEach((item) => {
		const { englishText, text } = item;
		translateData[englishText.key] = text.message;
	});
	return translateData;
};